import { Form, Select } from "antd";
import {
  getConfigAppPartType,
  renderSelection,
  getSelectionOptionsKey,
  isWorkerNameSelection,
  isSingleAppPartSelection,
  isAutoFillSelectionType,
  DELETED_SELECTION_TEXT,
  DELETED_SELECTION_VIEW_TEXT,
} from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { Styles } from "./styled";
import { AppSelectionList } from "@lhd/types";
import { useEffect, useMemo } from "react";

interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  selectionDataList: AppSelectionList;
  nameItem: string;
  isShareRecord?: boolean;
  styleColor?: React.CSSProperties;
  className?: string;
}

const CommonSelection = (props: IProps) => {
  const {
    item,
    style,
    selectionDataList,
    nameItem,
    preview,
    isTable,
    isDisable,
    isShareRecord,
    styleColor = {},
    className,
  } = props;
  const { isHiddenLabel, labelText, appPartType } = getConfigAppPartType(item);
  const optionsKey = getSelectionOptionsKey(
    appPartType,
  ) as keyof typeof selectionDataList;
  const form = Form.useFormInstance();
  const watchedValues = Form.useWatch(nameItem, form);
  const values =
    watchedValues !== undefined ? watchedValues : form?.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;
  const options = useMemo(
    () => selectionDataList[optionsKey] || [],
    [selectionDataList, optionsKey],
  );
  const isOptionsLoaded =
    !!selectionDataList[optionsKey] || preview || isShareRecord;

  const valuesArray = useMemo(() => {
    if (values === undefined || values === null || values === "") return [];
    if (Array.isArray(values)) {
      return values
        .filter((v: any) => v !== undefined && v !== null && v !== "")
        .map((v: any) => v.toString());
    }
    return [values.toString()];
  }, [values]);

  const valueText = useMemo(() => {
    const valuesText = valuesArray.map((value: any) => {
      const option = options.find(
        (x: any) => x.id?.toString() === value?.toString(),
      );
      if (option) {
        const optionWorker = `${option?.first_name} ${option?.last_name}`;
        return isWorkerNameSelection(appPartType)
          ? option.first_name && option.last_name
            ? optionWorker
            : option.name
          : option.name;
      }
      return DELETED_SELECTION_VIEW_TEXT;
    });
    return valuesText.filter((x: any) => !!x).join(",");
  }, [options, valuesArray, appPartType]);

  const isSingle = isSingleAppPartSelection(appPartType);

  const deletedValues = useMemo(() => {
    return valuesArray
      .map((v: any) => v?.toString())
      .filter(
        (valStr: string) =>
          valStr !== undefined &&
          valStr !== null &&
          valStr !== "" &&
          !options.some((opt: any) => opt.id?.toString() === valStr),
      );
  }, [valuesArray, options]);

  // useEffect(() => {
  //   if (isDisable || preview || isShareRecord) return;
  //   if (!isAutoFillSelectionType(appPartType)) return;
  //   if (options?.length === 1) {
  //     const currentValue = form?.getFieldValue(nameItem);
  //     const isEmpty =
  //       currentValue === undefined ||
  //       currentValue === null ||
  //       currentValue === "" ||
  //       (Array.isArray(currentValue) && currentValue.length === 0);
  //     if (isEmpty) {
  //       const singleOptionId = options[0].id.toString();
  //       const singleValue = isSingle ? singleOptionId : [singleOptionId];
  //       form?.setFieldValue(nameItem, singleValue);
  //     }
  //   }
  // }, [
  //   options,
  //   isDisable,
  //   preview,
  //   isShareRecord,
  //   appPartType,
  //   isSingle,
  //   form,
  //   nameItem,
  // ]);

  return (
    <Styles
      style={style}
      id={item.id}
      className={`full select-multiple ` + item.app_part_type}
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <div className="value_text_container">{isShowOnlyValue && valueText}</div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item.is_required_field,
            message: `必須項目です`,
          },
        ]}
        className={className}
      >
        <Select
          allowClear
          showSearch
          mode={isSingle ? undefined : "multiple"}
          loading={!selectionDataList[optionsKey] && !preview && !isShareRecord}
          tagRender={(props: any) => renderSelection(props, appPartType)}
          filterOption={(input, option: any) =>
            (option?.children ?? "")
              .toString()
              .toLowerCase()
              .includes(input.trim().toLowerCase())
          }
        >
          {options.map((option, i) => {
            const optionWorker = `${option?.first_name} ${option?.last_name}`;
            return (
              <Select.Option
                key={i}
                value={option.id.toString()}
                className="custom-option"
              >
                {isWorkerNameSelection(appPartType)
                  ? option.first_name && option.last_name
                    ? optionWorker
                    : option.name
                  : option.name}
              </Select.Option>
            );
          })}
          {deletedValues.map((deletedId, i) => (
            <Select.Option
              key={`deleted-${deletedId}-${i}`}
              value={deletedId}
              className="custom-option deleted-option"
            >
              {DELETED_SELECTION_TEXT}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Styles>
  );
};
export default CommonSelection;
